<template>
  <div :style="maxHeight" @mousewheel="getMaxHeight" style="overflow: hidden">
    <el-button type="primary">{{ $t('makeSchedule.planAchievementPage.wujianSelect') }}</el-button>
    <el-select v-model="fromData.wuJianId" @change="changeWuJianId" clearable :placeholder="$t('makeSchedule.planAchievementPage.wujianName')" class="wujian_select_size">
      <el-option
          v-for="item in wuJianNames"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  <el-row style="width: 100%;height:45%;margin-top: 10px">
    <div style="width: 50%;height:100%;border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;">
      <el-form :model="cutOffData" label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="cutOffData.day" @change="getCutOffProduction" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;"/>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="divSize" v-loading="cutOffOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height: 90%;" id="cutOffOutput"/>
    </div>

    <div style="width: 50%;height:100%;border-bottom: 8px solid whitesmoke;">
      <el-form :model="processData" label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="processData.day" @change="getProcessProduction" format="YYYY 年 M 月"
                            value-format="YYYY-M-1"
                            type="month" placeholder="选择月份" style="width: 140px;"/>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="divSize" v-loading="processOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height: 90%;" id="processOutput"/>
    </div>
  </el-row>

  <el-row style="width: 100%;height:50%;">
    <div style="width: 50%;height:100%;border-bottom: 8px solid whitesmoke;border-right: 8px solid whitesmoke;">
      <el-form label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="productiveYear" :clearable="false" format="YYYY 年" value-format="YYYY" type="year"
                            @change="getDayProductiveOutput" placeholder="请选择年份"
                            style="width: 100px;"/>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="productiveMonth" format="M 月" value-format="YYYY-M-1" type="month"
                            @change="productiveChangeMonth(productiveMonth)" placeholder="请选择月份"
                            style="width: 140px;"/>
          </el-form-item>
        </el-row>
      </el-form>
      <!-- 生产性-->
      <div v-loading="jiaGongProductiveOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height:90%;" id="jiaGongProductiveOutput"/>
    </div>
    <div style="width:50%;height:100%;border-bottom: 8px solid whitesmoke;">
      <el-form label-width="10px">
        <el-row>
          <el-form-item>
            <el-date-picker v-model="month" @change="getProduceActual" :clearable="false" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;"/>
          </el-form-item>
        </el-row>
      </el-form>
      <!--  生产实际-->
      <div v-loading="produceActualOutputLoading" element-loading-text="数据加载中"
           style="width: 100%;height:90%;;" id="produceActualOutput"/>
    </div>
  </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgProcessProduce",
  data() {
    return {
      maxHeight:'',
      fromData: {},
      wuJianNames: [],
      //typeList: [{value: true, label: "社内"}, {value: false, label: "社外"}],
      cutOffData: {
        day: this.getDateFormat(),
        wuJianId: '',
      },
      processData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      month: this.getDateFormat(),
      thing: '',
      countDayList: [],
      //切断产量（KG）
      cutOffOutput: {
        title: [
          {
            text: this.$t('makeSchedule.planAchievementPage.cutProduction'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = ''
            let total = 0
            for (const item of params) {
              if (item.value !== "0") {
                total  += Number(item.value)
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return `${params[0].name} <br/>` + `<span style="background:black; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:13.5px;"></span>${"总计"} : ${total.toFixed(1)}<br/>` + res
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {bottom: '30',},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '重量(kg)',
            min:0,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: '社内',
            stack: '社内',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '社外',
            type: 'bar',
            stack: '社内',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },

      cutOffOutputLoading: false,
      // 加工产量（KG）
      processOutput: {
        title: [
          {
            text: this.$t('makeSchedule.planAchievementPage.jgProduction'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = ''
            let total = 0
            for (const item of params) {
              if (item.value !== "0") {
                total  += Number(item.value)
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return `${params[0].name} <br/>` + `<span style="background:black; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:13.5px;"></span>${"总计"} : ${total.toFixed(1)}<br/>` + res
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '30',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '重量(kg)',
            min:0,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '累计重量(kg)',
            min:0,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: '社内',
            stack: '社内',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '社外',
            type: 'bar',
            stack: '社内',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.accumulated'),
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      processOutputLoading: false,
      //物件日生产生产实际
      produceActualOutput: {
        title: [
          {
            text: this.$t('makeSchedule.planAchievementPage.jgAchievements'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '30' ,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.planAchievementPage.jgActualAchievements'),
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.planAchievementPage.jgAccumulatedAchievements'),
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: this.$t('makeSchedule.planAchievementPage.plan'),
            type: 'bar',
           // yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.actualAchievements'),
            type: 'bar',
            yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.accumulatedPlan'),
            type: 'line',
            color:'#fac858',
            yAxisIndex:1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.accumulatedAchievements'),
            type: 'line',
            color:'#ee6666',
            yAxisIndex:1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      produceActualOutputLoading: false,
      //////////
      productiveThing:'',
      // productiveThings:[],
      productiveMonth : this.getDateFormat(),
      productiveYear:this.$common.getCurrentYearByMonth().toString(),
      //物件日生产性
      jiaGongProductiveOutput: {
        title: [
          {
            text: this.$t('makeSchedule.planAchievementPage.cutJgProductive'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '30' ,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '重量(kg)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.planAchievementPage.directProductivity'),
            min:0,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.planAchievementPage.productionWeight'),
            type: 'bar',
            yAxisIndex: 0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.directLabor'),
            stack: '人工',
            type: 'bar',
            yAxisIndex: 1,
            color:'#6cb5f9',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.indirectLabor'),
            stack: '人工',
            type: 'bar',
            color:'#fa9504',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.directProductivity'),
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.targetProductivity'),
            color:'#fac858',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.planAchievementPage.totalProductivity'),
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      jiaGongProductiveOutputLoading: false,
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight -140;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    getCountDays(month) {
      const d = new Date(month)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    renderEcharts(id, option, totalList) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        //处理
        chart.on('legendselectchanged', function (params) {
          //list1装 社内数据 list2 社外数据
          for (let item of option.series) {
            if (item.name == '社内') {
              option.list1 = item.data
            } else if (item.name == '社外') {
              option.list2 = item.data
            }
          }
          // params.selected['社内'] true：社内有值则无值
          if (params.selected['社内'] && params.selected['社外']) {
            option.yAxis[0].max = Math.ceil(Math.max(...totalList) / 10) * 10
            option.yAxis[0].interval = Math.round(option.yAxis[0].max / 5 * 100) / 100
          } else if (!params.selected['社内'] && params.selected['社外']) {
            option.yAxis[0].max = Math.ceil(Math.max(...option.list2) / 10) * 10
            option.yAxis[0].interval = Math.round(option.yAxis[0].max / 5 * 100) / 100
          } else if (params.selected['社内'] && !params.selected['社外']) {
            option.yAxis[0].max = Math.ceil(Math.max(...option.list1) / 10) * 10
            option.yAxis[0].interval = Math.round(option.yAxis[0].max / 5 * 100) / 100
          }
          chart.setOption(option)
        });
      }
    },
    changeWuJianId() {
      this.cutOffData.wuJianId = this.fromData.wuJianId
      this.getCutOffProduction();
      this.processData.wuJianId = this.fromData.wuJianId
      this.getProcessProduction();
      //this.productiveThing = this.fromData.wuJianId
      //this.getDayProductiveOutput();
      this.thing = this.fromData.wuJianId
      this.getProduceActual();
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getWujianNames');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
      // this.productiveThings = res.data;
    },
    // 切断产量（KG）
    async getCutOffProduction() {
      if (!this.cutOffData.day) {
        this.cutOffData.day = this.getDateFormat()
      }
      this.cutOffOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getCutOffProduction', this.cutOffData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.cutOffOutput.xAxis[0].data = res.data.xAxis
        this.cutOffOutput.series[0].data = res.data.productionWithinList
        this.cutOffOutput.series[1].data = res.data.productionOutsideList
        let a = this.$common.getDivisor(Math.max(...res.data.productionTotalList))
        this.cutOffOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.productionTotalList) / a) * (a + 3)
        this.cutOffOutput.yAxis[0].interval = Math.round(this.cutOffOutput.yAxis[0].max / 5 * 100) / 100
      }

      this.renderEcharts('cutOffOutput', this.cutOffOutput, res.data.productionTotalList)
      this.cutOffOutputLoading = false
    },

    // 加工产量（KG）
    async getProcessProduction() {
      if (!this.processData.day) {
        this.processData.day = this.getDateFormat()
      }
      this.processOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProcessProduction', this.processData);

      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.processOutput.xAxis[0].data = res.data.xAxis
        this.processOutput.series[0].data = res.data.processWithinList
        this.processOutput.series[1].data = res.data.processOutsideList
        this.processOutput.series[2].data = res.data.processCumulativeWithinList
        let a = this.$common.getDivisor(Math.max(...res.data.processTotalList))
        this.processOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.processTotalList) / a) * (a + 3)
        this.processOutput.yAxis[0].interval = Math.round(this.processOutput.yAxis[0].max / 5 * 100) / 100

        let b = this.$common.getDivisor(Math.max(...res.data.processCumulativeWithinList))
        this.processOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.processCumulativeWithinList) / b) * (b + 3)
        this.processOutput.yAxis[1].interval = Math.round(this.processOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('processOutput', this.processOutput, res.data.processTotalList)

      this.processOutputLoading = false
    },
    //生产实际
    async getProduceActual() {
      if (!this.month) {
        return this.$message.error('请先选择物件月份!')
      }
      let params = {countDayList: this.countDayList, thing:this.thing, month:this.month};
      this.produceActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProduceActual', params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.produceActualOutput.xAxis[0].data = res.data.xAxis
        this.produceActualOutput.series[0].data = res.data.planList
        this.produceActualOutput.series[1].data = res.data.actualList
        //this.produceActualOutput.series[2].data = res.data.differenceList
        this.produceActualOutput.series[2].data = res.data.accumulatePlanList
        this.produceActualOutput.series[3].data = res.data.accumulateActualList
        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)

        //let a = this.$common.getDivisor(Math.max(...res.data.actualList))
        this.produceActualOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.produceActualOutput.yAxis[0].interval = Math.round(this.produceActualOutput.yAxis[0].max / 5 * 100) / 100

        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.produceActualOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max / 5 * 100) / 100
        // let b = this.$common.getDivisor(Math.max(...res.data.accumulateActualList))
        // this.produceActualOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.accumulateActualList)/b)* (b + 5)
        // this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max/5*100)/100
      }
      this.renderEcharts('produceActualOutput', this.produceActualOutput)
      this.produceActualOutputLoading = false
    },
    ////////////////////
    productiveChangeMonth(month) {
      this.countDayList = [];
      this.getCountDays(month);
      this.getDayProductiveOutput();
    },
    //物件生产性
    async getDayProductiveOutput() {
      this.jiaGongProductiveOutputLoading = true
      if (!this.productiveYear) {
        return this.$message.error("年不能为空");
      }
      let params
      if (!this.productiveMonth) {
        params = {month:this.productiveMonth, year:this.productiveYear}
      } else {
        params = {countDayList: this.countDayList,month:this.productiveMonth, year:this.productiveYear};
      }
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getJiaGongProductive',params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.jiaGongProductiveOutput.xAxis[0].data = res.data.xAxis
        this.jiaGongProductiveOutput.series[0].data = res.data.weightList
        this.jiaGongProductiveOutput.series[1].data = res.data.zjTotalManHourList
        this.jiaGongProductiveOutput.series[2].data = res.data.jjTotalManHourList
        this.jiaGongProductiveOutput.series[3].data = res.data.directProductivityList
        this.jiaGongProductiveOutput.series[4].data = res.data.productivityList
        this.jiaGongProductiveOutput.series[5].data = res.data.totalProductiveList

        let a = this.$common.getDivisor(Math.max(...res.data.weightList))
        let b = this.$common.getDivisor(Math.max(...res.data.directProductivityList))
        this.jiaGongProductiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.weightList)/a)*(a + 3)
        this.jiaGongProductiveOutput.yAxis[0].interval = Math.round(this.jiaGongProductiveOutput.yAxis[0].max/5*100)/100
        this.jiaGongProductiveOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.directProductivityList)/b)*b
        this.jiaGongProductiveOutput.yAxis[1].interval = Math.round(this.jiaGongProductiveOutput.yAxis[1].max/5*0.5)/0.5
      }
      this.renderEcharts('jiaGongProductiveOutput',this.jiaGongProductiveOutput)

      this.jiaGongProductiveOutputLoading = false
    },
  },
  mounted() {
    this.getCutOffProduction()
    this.getProcessProduction()
    this.getProduceActual()
    //////////
    this.getDayProductiveOutput()
  },
  created() {
    this.getWuJianInFo()
    this.getCountDays(new Date());
    this.getMaxHeight()
  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>